import React, { useState } from 'react';

import AutoLink from "Components/AutoLink";
import DialogPortal from "Components/DialogPortal";
import DetailViewer from "./Popup/DetailViewer";
import ChatHeader from "../ChatHeader";


const Basic = ({ message, message_data_str, message_more, headerData }) => {
  const {roomInfo, writerInfo, date} = headerData;
  const [showDetail, setOpenDetail] = useState(false);
  

  return (
    <>
      <div className="cont">
        <div className="txt">
          <div className="data">
            <AutoLink text={(message + (message_more === '1' ? ' ...더보기' : '')) || ' '} />
          </div>
          {message_more === '1' ? (<button type="button" className="detailView" onClick={setOpenDetail.bind(null, true)}>상세보기</button>) : null}
        </div>
      </div>
      {
        showDetail ?
          <DialogPortal>
            <DetailViewer body={(
              <>
                <ChatHeader roomInfo={roomInfo} writerInfo={writerInfo} date={date} />
                <div className="cont">
                  <div className="txt">
                    <div className="data">
                      <AutoLink text={message_data_str || ' '} />
                    </div>
                  </div>
                </div>
              </>
            )} callback={setOpenDetail.bind(null, false)} />
          </DialogPortal> : null
      }
    </>
  )
}

export default React.memo(Basic);